import { createContext } from 'react';
import { UserProfile } from '../../interfaces';

export const AuthContext = createContext<{
  user: UserProfile | null;
  signinRedirect: () => Promise<void>;
  signinRedirectCallback: () => Promise<void>;
  signinSilent: () => Promise<void>;
  signout: () => void;
  signoutRedirectCallback: () => Promise<void>;
}>(null!);
